/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserNotification
 */
export interface UserNotification {
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    user_id: string;
    /**
     * 
     * @type {number}
     * @memberof UserNotification
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    kind?: UserNotificationKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    content?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserNotification
     */
    attachments?: Array<string>;
}


/**
 * @export
 */
export const UserNotificationKindEnum = {
    Sms: 'sms',
    Ios: 'ios',
    Android: 'android',
    Email: 'email'
} as const;
export type UserNotificationKindEnum = typeof UserNotificationKindEnum[keyof typeof UserNotificationKindEnum];


/**
 * Check if a given object implements the UserNotification interface.
 */
export function instanceOfUserNotification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;

    return isInstance;
}

export function UserNotificationFromJSON(json: any): UserNotification {
    return UserNotificationFromJSONTyped(json, false);
}

export function UserNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user_id': json['user_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
    };
}

export function UserNotificationToJSON(value?: UserNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'date': value.date,
        'kind': value.kind,
        'to': value.to,
        'title': value.title,
        'content': value.content,
        'attachments': value.attachments,
    };
}

